<template>
  <div class="ed-shop">
    <div v-if="!loading" class="ed-shop__inner">

      <!-- Master overview -->
      <section v-if="profile_shop.master === true" class="ed-shop__section">
        <header class="ed-shop__h">
          <span class="ed-shop__h-num">C1</span>
          <h3 class="ed-shop__h-title">Estadísticas generales</h3>
          <span class="ed-shop__h-rule"></span>
        </header>
        <div class="ed-shop__panel">
          <StatisticsDashboard :compras="compras" :compra_location="compra_location" />
        </div>
      </section>

      <!-- Applicant view -->
      <section
        v-if="profile_shop.solicitante === true || profile_shop.master === true || $store.state.auth.user.user.permition_level === 99"
        class="ed-shop__section"
      >
        <header class="ed-shop__h">
          <span class="ed-shop__h-num">C2</span>
          <h3 class="ed-shop__h-title">Solicitante</h3>
          <span class="ed-shop__h-rule"></span>
          <span class="ed-shop__h-meta">Estado de tus solicitudes</span>
        </header>
        <div class="ed-shop__panel">
          <ApplicantDashboard :status_request="status_request" :compra_location="compra_location" />
        </div>
      </section>

      <!-- Approvers -->
      <section
        v-if="profile_shop.aprobador === true || profile_shop.master === true"
        class="ed-shop__section"
      >
        <header class="ed-shop__h">
          <span class="ed-shop__h-num">C3</span>
          <h3 class="ed-shop__h-title">Aprobaciones</h3>
          <span class="ed-shop__h-rule"></span>
          <span class="ed-shop__h-meta">Órdenes pendientes</span>
        </header>
        <div class="ed-shop__panel">
          <Approvers
            :series="series_aprobador"
            :labels="labels_aprobador"
            :all_data="aprobador_data"
            :detail_orders="pending_orders"
          />
        </div>
      </section>

      <!-- Buyer -->
      <section
        v-if="profile_shop.comprador === true || profile_shop.master === true"
        class="ed-shop__section"
      >
        <header class="ed-shop__h">
          <span class="ed-shop__h-num">C4</span>
          <h3 class="ed-shop__h-title">Comprador</h3>
          <span class="ed-shop__h-rule"></span>
          <span class="ed-shop__h-meta">Estado de órdenes de compra</span>
        </header>
        <div class="ed-shop__panel">
          <OrderDashboard :orders="orders" />
        </div>
      </section>
    </div>

    <div v-else class="ed-shop__loader">
      <div class="ed-shop__sk" v-for="n in 2" :key="n"></div>
    </div>
  </div>
</template>

<script>
import StatisticsDashboard from "@/components/Shop/Dashboards/StatisticsDashboard.vue";
import ApplicantDashboard from "@/components/Shop/Dashboards/ApplicantDashboard.vue";
import QuoteDashboard from "@/components/Shop/Dashboards/QuoteDashboard.vue";
import OrderDashboard from "@/components/Shop/Dashboards/OrderDashboard.vue";
import ReceiptDashboard from "@/components/Shop/Dashboards/ReceiptDashboard.vue";
import Approvers from "@/components/Shop/Dashboards/Approvers.vue";

export default {
  components: {
    StatisticsDashboard,
    ApplicantDashboard,
    OrderDashboard,
    QuoteDashboard,
    ReceiptDashboard,
    Approvers,
  },
  props: {
    filters: {
      type: Object,
      default: () => ({ business: null, location: null, department_id: null }),
    },
  },
  watch: {
    filters: { handler(v) { this.updateData(v); }, deep: true, immediate: true },
  },
  data: () => ({
    loading: false,
    status_request: { series: [], label: [] },
    compra_location: { series: [], label: [] },
    compras: { series: [], label: [] },
    orders: { series: [], label: [] },
    series_contador: [], labels_contador: [], contador_data: [],
    series_aprobador: [], labels_aprobador: [], aprobador_data: [],
    pending_orders: [],
    profile_shop: {
      master: false, solicitante: false, comprador: false,
      aprobador: false, contador: false, recepcionista: false, facturacion: false,
    },
  }),
  methods: {
    fetchCached(endpoint, payload) {
      return this.$store.dispatch("dashboard/fetchCached", {
        endpoint, payload,
        fetcher: async () => {
          const r = await this.api_Post(endpoint, payload);
          return await r.json();
        },
      });
    },

    async updateData(data) {
      this.loading = true;
      try {
        const featureCodes = this.$store.state.auth.globalFeatures || [];

        if (featureCodes.includes("SHOP-04")) { await this.Getsolicitante(data); this.profile_shop.solicitante = true; }
        if (featureCodes.includes("SHOP-11")) { await this.getComprador(data);  this.profile_shop.comprador  = true; }
        if (featureCodes.includes("SHOP-14")) { await this.getAprover();        this.profile_shop.aprobador  = true; }
        if (featureCodes.includes("SHOP-16")) { await this.getContador();       this.profile_shop.contador   = true; }
        if (featureCodes.includes("SHOP-13")) { this.profile_shop.recepcionista = true; }
        if (featureCodes.includes("SHOP-142") || featureCodes.includes("SHOP-143")) {
          this.profile_shop.facturacion = true;
        }
      } finally {
        this.loading = false;
      }
    },

    async getMaster(filter) {
      const [comprasMonth, comprasLocations] = await Promise.all([
        this.fetchCached("income/dashboard_montly",   { invoice: 1, business: filter.business, location: filter.location }),
        this.fetchCached("income/dashboard_location", { invoice: 1, business: filter.business, location: filter.location }),
      ]);
      const compra_location_label = [], compra_location_series = [];
      const compras_label = [], compras_series = [];
      for (const item of (comprasMonth || [])) {
        compras_label.push(item.month_year);
        compras_series.push(item.total_sales);
      }
      for (const item of (comprasLocations || [])) {
        compra_location_label.push(item.description_short);
        compra_location_series.push(parseFloat(item.total_amount_sum));
      }
      this.compra_location = { label: compra_location_label, series: compra_location_series };
      this.compras = { label: compras_label, series: compras_series };
    },

    async Getsolicitante(filter) {
      const statusRequest = await this.fetchCached(
        "shopping/get_request_status",
        { business: filter.business }
      );
      const status_request_label = [], status_request_series = [];
      for (const item of (statusRequest || [])) {
        status_request_label.push(item.status_description === "Actualizada" ? "Completada" : item.status_description);
        status_request_series.push(parseFloat(item.quantity));
      }
      this.status_request = { label: status_request_label, series: status_request_series };
    },

    async getContador() {
      let filters = " ";
      filters += " AND  BUSINESS_UNIT_ID in (" + this.$store.state.auth.user.acess_business_unit_finance + ") ";
      filters += "AND last_status_id in  (2,3) ";

      this.contador_data = [];
      this.labels_contador = [];
      this.series_contador = [];
      const resultOrders = await this.api_Post("shopping/orders_dasboard", { filters });
      const data = await resultOrders.json();
      this.contador_data = data;
      for (const item of data) {
        this.labels_contador.push(item.name);
        this.series_contador.push(parseFloat(item.quantity));
      }
    },

    async getAprover() {
      this.aprobador_data = [];
      this.labels_aprobador = [];
      this.series_aprobador = [];
      this.pending_orders = [];
      const user_id = this.$store.state.auth.user.user.user_id;
      const [resultOrders, resultDetail] = await Promise.all([
        this.api_Post("shopping/orders_aprovers", { user_id }),
        this.api_Post("shopping/orders_aprovers_detail", { user_id }),
      ]);
      const data = await resultOrders.json();
      this.aprobador_data = data;
      for (const item of data) {
        this.labels_aprobador.push(item.location_name || item.name);
        this.series_aprobador.push(parseFloat(item.quantity));
      }
      this.pending_orders = await resultDetail.json();
      this.$store.commit("auth/SET_PENDING_APPROVALS", this.pending_orders.length);
    },

    async getComprador(filter) {
      const statusOrders = await this.fetchCached(
        "shopping/get_order_status",
        { business: filter.business }
      );
      const status_orders_label = [], status_orders_series = [];
      for (const item of (statusOrders || [])) {
        status_orders_label.push(item.last_status_name);
        status_orders_series.push(parseFloat(item.quantity));
      }
      this.orders = { label: status_orders_label, series: status_orders_series };
    },
  },
};
</script>

<style lang="scss" scoped>
$ink:          #2A3547;
$muted:        #5A6A85;
$muted-soft:   #8A98AB;
$rule:         #E5EAF2;
$bg:           #F7F9FC;
$card:         #FFFFFF;
$primary:      #00897B;
$primary-soft: #E0F2F1;
$info:         #2196F3;
$info-soft:    #E3F2FD;
$accent:       #5C6BC0;
$accent-soft:  #E8EAF6;
$warning:      #F57F17;
$warning-soft: #FFF3E0;
$error:        #E53935;
$success:      #2E7D32;
$shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 8px 18px -6px;

$font: 'Plus Jakarta Sans', sans-serif;

.ed-shop { font-family: $font; color: $ink; padding: 12px 0 24px; }
.ed-shop__inner { display: flex; flex-direction: column; gap: 36px; }
.ed-shop__section { display: flex; flex-direction: column; gap: 14px; }

.ed-shop__h { display: flex; align-items: center; gap: 14px; }
.ed-shop__h-num { font-family: $font; font-size: 11px; font-weight: 700; color: $primary; letter-spacing: .14em; text-transform: uppercase; }
.ed-shop__h-title { font-family: $font; font-weight: 700; font-size: 22px; letter-spacing: -.01em; color: $ink; margin: 0; }
.ed-shop__h-rule { flex: 1; height: 1px; background: $rule; }
.ed-shop__h-meta { font-family: $font; font-size: 11px; font-weight: 600; color: $muted; letter-spacing: .14em; text-transform: uppercase; }

.ed-shop__panel { background: $card; border: 1px solid $rule; border-radius: 14px; box-shadow: $shadow; padding: 22px; }
.ed-shop__panel ::v-deep .v-card { box-shadow: none !important; border: 0 !important; }
.ed-shop__panel ::v-deep .modern-card {
  background: transparent !important; border: 0 !important; padding: 0 !important;
  box-shadow: none !important; border-radius: 0 !important;
}

.ed-shop__loader { display: flex; flex-direction: column; gap: 18px; padding: 12px 0; }
.ed-shop__sk {
  height: 160px;
  background: linear-gradient(90deg, $bg 0%, #EEF1F6 50%, $bg 100%);
  background-size: 200% 100%; animation: shimmer 1.4s linear infinite;
  border: 1px solid $rule;
  border-radius: 14px;
}
@keyframes shimmer { 0%{background-position:200% 0;} 100%{background-position:-200% 0;} }
</style>
